import ProjectsParticipants from './ProjectsParticipants';

export default ProjectsParticipants;
